// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"346":"aab1c506","801":"09ea74b8"}[chunkId] + ".chunk.js";
};